import { render, staticRenderFns } from "./ActionPlanRisk.vue?vue&type=template&id=29b720fd"
import script from "./ActionPlanRisk.vue?vue&type=script&lang=js"
export * from "./ActionPlanRisk.vue?vue&type=script&lang=js"
import style0 from "./ActionPlanRisk.vue?vue&type=style&index=0&id=29b720fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports